'use client';

import { Button, Stack } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';
import { flagSelectorRegions } from './region';
export interface FlagRegionSelectorProps {
  region: string;
}

export function FlagRegionSelector({ region }: FlagRegionSelectorProps) {
  const availableRegions = flagSelectorRegions.filter(x => x !== region);

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      {availableRegions.map(reg => {
        const countryCode = reg === 'UK' ? 'GB' : reg;
        return (
          <Button
            key={reg}
            variant="outlined"
            color="secondary"
            component={'a'}
            href={`/switch-region?region=${reg}`}
            sx={{ minWidth: '2rem', justifyContent: 'center' }}
          >
            <ReactCountryFlag countryCode={countryCode} svg />
          </Button>
        );
      })}
    </Stack>
  );
}
